import React from "react";
import './knowMoreTemple.css';

function KnowMoreTemple() {
    return (
        <section id="services-964">
            <div className="cs-container">
                <div className="cs-content">
                    <span className="cs-topper">Your Temple</span>
                    <h2 className="cs-title">Know your Temple</h2>
                    <img src="/images/article-details-large.jpg" ></img>
                    <p className="cs-text">
                    Welcome to the Krishna Temple — a sacred place of devotion, learning, and community.
                    Here, ancient traditions come alive through daily worship, heartfelt kirtans, and the timeless wisdom of the Bhagavad Gita.
                    The temple is not just a building; it is a spiritual home where every soul is welcomed with love and respect.                    </p>
                </div>
                <ul className="cs-card-group">
                    <li className="cs-item">
                        <picture className="cs-icon-wrapper">
                            <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/trees-white.svg" alt="hair cut" width="40" height="40"></img>
                        </picture>
                        <h3 className="cs-h3">Daily Worship and Arati</h3>
                        <p className="cs-item-text">
                            Beautiful ceremonies offered to the Deities throughout the day.
                        </p>
                        <a href="/about-krishna-temple">Read More</a>
                        <picture className="cs-background">
                            <img loading="lazy" decoding="async" src="/images/krishna-background.jpg" alt="hair cut" width="480" height="425"></img>
                        </picture>
                    </li>
                    <li className="cs-item">
                        <picture className="cs-icon-wrapper">
                            <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/trees-white.svg" alt="hair cut" width="40" height="40"></img>
                        </picture>
                        <h3 className="cs-h3">Sunday Kirtan and Feast</h3>
                        <p className="cs-item-text">
                            Joyful chanting of the Hare Krishna mantra followed by a delicious vegetarian feast.
                        </p>
                        <a href="/temple-kirtan">Read More</a>
                        <picture className="cs-background">
                            <img loading="lazy" decoding="async" src="/images/krishna-background.jpg" alt="hair cut" width="480" height="425"></img>
                        </picture>
                    </li>
                    <li className="cs-item">
                        <picture className="cs-icon-wrapper">
                            <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/trees-white.svg" alt="hair cut" width="40" height="40"></img>
                        </picture>
                        <h3 className="cs-h3">Festivals and Celebrations</h3>
                        <p className="cs-item-text">
                        Grand celebrations for Janmashtami, Rath Yatra, Holi, Diwali, and more.
                        </p>
                        <a href="/krishna-temple-events">Read More</a>
                        <picture className="cs-background">
                            <img loading="lazy" decoding="async" src="/images/krishna-background.jpg" alt="hair cut" width="480" height="425"></img>
                        </picture>
                    </li>
                    <li className="cs-item">
                        <picture className="cs-icon-wrapper">
                            <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/trees-white.svg" alt="hair cut" width="40" height="40"></img>
                        </picture>
                        <h3 className="cs-h3">Volunteer Opportunities</h3>
                        <p className="cs-item-text">
                        Serve the temple community through various activities.
                        </p>
                        <a href="/krishna-volunteer">Read More</a>
                        <picture className="cs-background">
                            <img loading="lazy" decoding="async" src="/images/krishna-background.jpg" alt="hair cut" width="480" height="425"></img>
                        </picture>
                    </li>
                    <li className="cs-item">
                        <picture className="cs-icon-wrapper">
                            <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/trees-white.svg" alt="hair cut" width="40" height="40"></img>
                        </picture>
                        <h3 className="cs-h3">Food Offering</h3>
                        <p className="cs-item-text">
                        Devotees can offer vegetarian meals to the deity with discussion with the Temple management.
                        </p>
                        <a href="/krishna-temple-contact">Read More</a>
                        <picture className="cs-background">
                            <img loading="lazy" decoding="async" src="/images/krishna-background.jpg" alt="hair cut" width="480" height="425"></img>
                        </picture>
                    </li>
                    <li className="cs-item">
                        <picture className="cs-icon-wrapper">
                            <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/trees-white.svg" alt="hair cut" width="40" height="40"></img>
                        </picture>
                        <h3 className="cs-h3">Sponsorship Opportunities</h3>
                        <p className="cs-item-text">
                        Sponsor festivals, meals, deity worship, and other spiritual activities.
                        </p>
                        <a href="/donate">Read More</a>
                        <picture className="cs-background">
                            <img loading="lazy" decoding="async" src="/images/krishna-background.jpg" alt="hair cut" width="480" height="425"></img>
                        </picture>
                    </li>
                </ul>
            </div>
            <picture className="cs-waves">
                <source media="(max-width: 600px)" srcSet="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/waves-m.svg"></source>
                <source media="(min-width: 601px)" srcSet="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/waves.svg"></source>
                <img loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/waves.svg" alt="waves graphic" width="1920" height="331" aria-hidden="true"></img>
            </picture>
        </section>
    );
}
export default KnowMoreTemple;
